import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]

  toggle(event) {
    const row = event.target.closest('[data-view]')
    const select = this.visibility(row)
    const enabled = event.target.checked
    if (select) {
      if (!enabled && select.value !== "hidden") row.dataset.audience = select.value
      select.value = enabled ? (row.dataset.audience === "hidden" ? "owner" : row.dataset.audience) : "hidden"
      this.application.getControllerForElementAndIdentifier(select.closest('[data-controller~="profile-audience"]'), "profile-audience")?.sync()
    }
    this.defaults()
  }

  visibilityChanged(event) {
    const row = this.rowTargets.find(row => this.visibility(row) === event.target)
    if (!row) return
    row.querySelector('[role=switch]').checked = event.target.value !== "hidden"
    if (event.target.value !== "hidden") row.dataset.audience = event.target.value
    this.defaults()
  }

  visibility(row) { return this.element.querySelector(`select[name="profile_page[section_visibility][${row.dataset.section}]"]`) }

  defaults() {
    this.rowTargets.forEach(row => {
      const radio = row.querySelector('[type=radio]')
      radio.disabled = !row.querySelector('[role=switch]').checked
      if (radio.disabled) radio.checked = false
    })
    if (!this.rowTargets.some(row => row.querySelector('[type=radio]').checked)) {
      const radio = this.rowTargets.find(row => !row.querySelector('[type=radio]').disabled)?.querySelector('[type=radio]')
      if (radio) radio.checked = true
    }
  }
}
